
<style scoped>
	.tableInputNumber /deep/ .el-input .el-input__inner {
		width: 100px;
	}
  /deep/ .el-divider--horizontal {
    margin: 0 0 10px 0;
  }
</style>
<template>
	<div>
		<div class="container">
			<div class="form-container">
				<el-form ref="form" :rules="rules" :model="form" :inline="true" :label-width="formLabelWidth" size="mini" v-loading="enabledLoading">
            <el-form-item :label="$t('shebeimingcheng')" prop="name" class="noborder">
              {{row.name}}
            </el-form-item>
            <el-form-item :label="$t('shebeiSN')" prop="sn" class="noborder">
              {{row.sn}}
            </el-form-item>
            <el-form-item :label="$t('shebeixinghao')" prop="code" class="noborder">
              {{row.model.code}}
            </el-form-item>
            <el-form-item :label="$t('shebeileixing')" prop="code" class="noborder">
              {{$t(store.state.dictJson['EQUIPMENT_TYPES'][row.typeId])}}
            </el-form-item>
          <el-divider style="margin: 0 0 10px 0"></el-divider>
					<el-row>
						<el-col :span="24">
              <el-tabs >
                <el-tab-pane v-for="sub in form.datas" :key="sub.dict" :label="$t(store.state.dictJson['EQUIPMENT_CRAFT_CLASSIFICATION'][sub.dict])" >
                  <el-table stripe  :row-style="{height:42+'px'}" :cell-style="{padding:0+'px'}"
                    :header-cell-style="{background:'#F5F7FA',color:'#606266','font-weight':'700', height:'48px', padding:'0px'}"
                    :data="sub.data" size="mini" style="width:100%" border>
                    <el-table-column align="center" :label="$t('canshumiaoshu')">
                      <template slot-scope="scope">
                        <span>{{ $t(scope.row.i18n) }}</span>
                        <span v-if="scope.row.unit">/{{ scope.row.unit }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column align="center" width="100" :label="$t('craft_threshold_configuration_lower_rules')">
                      <template slot-scope="scope">
                        <div>   {{$t(store.state.dictJsonAll['point_upper_lower_rule_type'][scope.row.lowerRules])}}</div>
<!--                        <yi_dictionary_select :type="'point_upper_lower_rule_type'" :ids.sync="scope.row.lowerRules" :disabled="true">
                        </yi_dictionary_select>-->
                      </template>
                    </el-table-column>
                    <el-table-column align="center" width="80" :label="$t('craft_threshold_configuration_lower_default')">
                      <template slot-scope="scope">
                        <span>{{ scope.row.lowerDefault }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column align="center" width="100" :label="$t('craft_threshold_configuration_upper_rules')">
                      <template slot-scope="scope">
                        <div>
                          {{$t(store.state.dictJsonAll['point_upper_lower_rule_type'][scope.row.upperRules])}}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column align="center" width="150" :label="$t('craft_threshold_configuration_upper_default')">
                      <template slot-scope="scope">
                        <span>{{ scope.row.upperDefault }}</span>
                      </template>
                    </el-table-column>

                    <el-table-column width="120" :label="$t('craft_threshold_configuration_lower_set')">
                      <template slot-scope="scope">
                        <el-input-number size="mini" v-model="scope.row.lowerSet" v-if="scope.row.lowerRules == 'fixed'"
                                         :controls="false" class="tableInputNumber" :max="scope.row.upperDefault?parseFloat(scope.row.upperDefault):null" :min="scope.row.lowerDefault?parseFloat(scope.row.lowerDefault):null"
                                         :precision="scope.row.prec == null?2:scope.row.prec" />
                        <span v-else> {{scope.row.lowerSet}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column width="120" :label="$t('craft_threshold_configuration_upper_set')">
                      <template slot-scope="scope">
                        <el-input-number size="mini" v-model="scope.row.upperSet" v-if="scope.row.upperRules == 'fixed'"
                          :controls="false" class="tableInputNumber" :max="scope.row.upperDefault?parseFloat(scope.row.upperDefault):null" :min="scope.row.lowerDefault?parseFloat(scope.row.lowerDefault):null"
                          :precision="scope.row.prec == null?2:scope.row.prec" />
                        <span v-else> {{scope.row.upperSet}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column  :label="$t('kexiugaiguize')">
                      <template slot-scope="scope">
                        <el-input size="mini" v-model="scope.row.modifiableRule" style="min-width: 50px !important;"></el-input>
                      </template>
                    </el-table-column>

                  </el-table>
                  <br/>
                </el-tab-pane>
              </el-tabs>
						</el-col>
					</el-row>
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
    name: 'web_process_distribution_threshold_configuration_list_set',
		data() {
			return {
				form: {
					equipmentId: null,
					datas: [],
				},
				rules: {
				},
        enabledLoading:false,
				labelWidth: '70px',
				labelPosition: 'left',
			}
		},
		props: {
			formLabelWidth: {
				type: [String]
			},
      row: {
				type: [Object],
				required: true
			},

		},
		created() {
      this.form.equipmentId = this.row.id;
      this.getDetail()
		},
		methods: {

			// 详情
			getDetail() {
				const params = {
					equipmentId: this.row.id
				}
       this.enabledLoading = true;
				return this.http.get('/web/craft/threshold_configuration/listConfiguration?' + this.qs.stringify(params))
					.then(async (response) => {
            this.enabledLoading = false;
						this.form.datas = response.data;
					}).catch((error) => {
            this.enabledLoading = false;
            console.log(error)
            this.$message.error(this.$t(error));
          });
			},

		}
	}
</script>
